import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation2";
import { Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import services from "../../API/services";
import { getRroomUsersAction, usersSeletor } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import decodeEntities from "../../Common/DecodeHtml";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";

const rRoomsRoles = {
  1: [2, 8, 9, 10, 11, 12, 13, 14, 29],
  2: [8, 9, 10, 11, 12, 13, 14],
  8: [9, 10, 11, 12, 13, 14],
  9: [10, 11, 12, 13, 14],
  10: [11, 12, 13, 14],
  11: [12, 13],
}

const RRoomsUsers = () => {
  const dispatch = useDispatch();
  const { rRoomUsers } = useSelector(usersSeletor);
  const [selectData, setSelectData] = useState({});
  const [showAllRoles, setShowAllRoles] = useState([]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otherErrors, setOtherErrors] = useState({});
  const [selectedPropertyUser, setSelectedPropertyUser] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getRroomUsersAction());
  }, []);

  const tableRef = useRef(null);

  useEffect(() => { setUserList(rRoomUsers) }, [rRoomUsers]);

  const { AlertIcon } = Imagesdata || {};
  const { userDetail } = useSelector(authenticationSeletor);
  const [show, setShow] = useState(false);
  const [userList, setUserList] = useState([]);
  const [showUserList, setShowUserList] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({ ...validation, mode: "onSubmit" });

  const onSubmit = async (payload) => {
    const realPayload = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      name: payload.firstName + " " + payload.lastName,
      email: payload.email,
      mobile: payload.phoneNumber,
      role: Number(payload.role),
      password: payload.password,
      // designation: payload.designation,
    };
    try {
      let res = {};
      let msg = "";
      if (editMode) {
        realPayload.updatedBy = userDetail?.id;
        res = await services.user.editRRoomUserService(selectData.id, realPayload);
        msg = "Updated";
      } else {
        realPayload.createdBy = userDetail?.id;
        res = await services.user.addRRoomUserService(realPayload);
        msg = "Created";
      }
      setEditMode(false);
      if (res.status === 200) {
        reset();
        // setValue("designation", "");
        setValue("role", "");
        dispatch(getRroomUsersAction());
        setShow(false);
        toast.success(`Rrooms User ${msg} SuccessFull !`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
      }
    } catch (error) { console.log("Error in onSubmit function.") }
  };

  const getRoles = async () => {
    const res = await services.auth.getAllRoles();
    if (res.status == 200) { setShowAllRoles(res.data.data); }
  };

  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure want to delete User")) {
      try {
        const res = await services.auth.deleteRroomsUser(id);
        if (res.status == 200) {
          dispatch(getRroomUsersAction());
          toast.success("User Deleted Successfull !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
      } catch (error) { console.log("Error in deleteHandler function.") }
    }
  };

  const editHandler = async (data) => {
    setSelectData(data);
    setEditMode(true);
    setValue("firstName", data.firstName);
    setValue("lastName", data.lastName);
    setValue("email", data.email);
    setValue("phoneNumber", data.mobile);
    // setValue("designation", data.designation);
    setValue("password", data.password);
    setValue("confirmPassword", data.password);
    setValue("role", data.role);
    setShow(true);
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Users table",
    sheet: "Users",
  });

  const filterData = [
    { name: "Department", id: "department" },
    { name: "Manager", id: "manager" },
    { name: "Designation", id: "designation" },
  ];

  const searchfilter = (text) => {
    const results = userList.filter((item) => {
      if (text == "0") return userList;
      return item?.name?.toLocaleLowerCase()?.includes(text);
    });
    setShowUserList(results);
  };

  useEffect(() => {
    getRoles();
    setShowUserList(userList);
  }, [userList]);

  const validate = () => {
    const newErrors = {};
    if (!password) { newErrors.password = 'Password is required'; }
    else if (password.length < 4) { newErrors.password = 'Password must be at least 6 characters'; }
    if (!confirmPassword) { newErrors.confirmPassword = 'Confirm Password is required'; }
    else if (password != confirmPassword) { newErrors.confirmPassword = 'Passwords do not match'; }
    setOtherErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = { password: password, role: userDetail?.role }
      const res = await services.auth.rroomUserChangePasswordService(selectedPropertyUser?.id, payload)
      if (res.status === 200 && res.data.status === true) {
        toast.success(res.data.message, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        setSelectedPropertyUser(null)
      }
    }
  };

  const allowRoles = rRoomsRoles[userDetail?.role]

  return (
    <Layout
      title="RRooms Users"
      openHandler={() => setShow(true)}
      extraButton="Export Table"
      extraBtnHandler={onDownload}
      optionData={filterData}
      type="dropdown"
      searchfilter={searchfilter}
    >
      <table className="dashboard-table" ref={tableRef}>
        <thead>
          <tr>
            <th>S. No.</th>
            <th>Name</th>
            <th>User Code</th>
            {/* <th>Designation</th> */}
            <th>Role</th>
            <th>Email</th>
            <th>mobile</th>
            <th>Created By</th>
            <th>Edited By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {showUserList.map((data, key) => (
            <tr key={key}>
              <td data-label="S. No.">{key + 1}</td>
              <td data-label="Name">{data.firstName + " " + data.lastName}</td>
              <td data-label="User Code">{data.userCode}</td>
              {/* <td>{USER_DEG_TEXT[data.designation]}</td> */}
              <td data-label="Role">{data.Role?.roleName ?? "N/A"}</td>
              <td data-label="Email">{data.email ? decodeEntities(data.email) : "N/A "}</td>
              <td data-label="mobile">{data.mobile}</td>
              <td data-label="Created By">{userList?.find((i) => i.id == data.createdBy)?.firstName ?? "N/A"}</td>
              <td data-label="Edited By">{userList?.find((i) => i.id == data.updatedBy)?.firstName ?? "N/A"}</td>
              <td data-label="Action">
                {(userDetail?.logintype == "rroomUser") || (userDetail?.role == 1 && userDetail?.role == 2) ?
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-2"
                    onClick={() => setSelectedPropertyUser(data)}>
                    Change Password
                  </button>
                  : ''}
                <Button variant="primary" className="mr-2" onClick={() => editHandler(data)}>
                  <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                </Button>
                {userDetail?.role == 1 &&
                  <Button variant="danger" className="mr-2" onClick={() => deleteHandler(data.id)}>
                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                  </Button>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={`otpModal  ${selectedPropertyUser ? 'active' : ''}`}>
        <div className="innerOtpModal" style={{ minWidth: '400px' }}>
          <section className=" verify-otp-booking position-relative">
            <button
              className="btn closeBtn text-black position-absolute top-0 end-0 m-0"
              onClick={() => setSelectedPropertyUser(null)}
            >
              <FontAwesomeIcon icon="fa-solid fa-x" />
            </button>
            <div className="title text-black fs-4 text-left pb-4">Change Password</div>
            <form onSubmit={handlePasswordSubmit}>
              <div className="form-group">
                <label className="field-label text-left">New Password</label>
                <input
                  type="text"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="field-control"
                  placeholder="New Password"
                />
                {otherErrors.password && <span className="d-block text-left" style={{ color: 'red' }}>{otherErrors.password}</span>}
              </div>
              <div className="form-group">
                <label className="field-label text-left">Confirm New Password</label>
                <input
                  type="text"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="field-control"
                  placeholder="Confirm New Password"
                />
                {otherErrors.confirmPassword && <span className="d-block text-left" style={{ color: 'red' }}>{otherErrors.confirmPassword}</span>}
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary" disabled={!password || !confirmPassword || Object.keys(errors).length > 0}>
                  Submit
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>

      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          reset();
          // setValue("designation", "");
          setValue("role", "");
        }}
        size="lg" backdrop="static">
        <Modal.Header closeButton><Modal.Title>New user details</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form" onSubmit={handleSubmit(onSubmit)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group"></Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="firstName"
                    text="First Name"
                    type="text"
                    autoFocus={true}
                    placeholder="Enter first name"
                    field={"firstName"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.firstName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"firstName"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="lastName"
                    text="Last Name"
                    type="text"
                    placeholder="Enter Last name"
                    field={"lastName"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.lastName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"lastName"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="phoneNumber"
                    text="Phone No."
                    type="text"
                    placeholder="Enter phone number"
                    field={"phoneNumber"}
                    register={register}
                    errors={errors}
                    max={10}
                  />
                  {errors?.phoneNumber?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"phoneNumber"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="email"
                    text="Email address "
                    type="email"
                    placeholder="Enter email address"
                    field={"email"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.email?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"email"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group flex flex-column">
                  <label>Role</label>
                  <select style={{ height: 45, outline: 0 }} register={register} {...register("role")} className={`form-select`}>
                    <option disabled selected value="">Select User Role</option>
                    {showAllRoles?.filter((data) => data.roleName.includes('RROOMS') && allowRoles.includes(data.id)).map((item) => {
                      return (<option value={item.id} key={item.id}>{item.roleName}</option>);
                    })}
                  </select>
                  {errors?.role?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"role"} /></span>
                    </div>
                  )}
                </Col>
                {/* <Col xs={6} className="form-group flex flex-column">
                  <label>Designation</label>
                  <select
                    style={{ height: 45, outline: 0 }}
                    register={register}
                    {...register("designation")}
                    className={`formControl border`}
                  >
                    <option disabled selected value="">
                      Select User Designation
                    </option>
                    {userDetail.designation == "1"
                      ? USER_DEG_TEXT_WITH_ANUM.map((item, ind) => {
                          return (
                            <option value={item.value} key={ind}>
                              {item.name}
                            </option>
                          );
                        })
                      : USER_DEG_TEXT_WITH_ANUM.map((item, ind) => {
                          if (userDetail.designation < item.value) {
                            return (
                              <option value={item.value} key={ind}>
                                {item.name}
                              </option>
                            );
                          }
                        })}
                  </select>
                  {errors?.designation?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"designation"} />
                      </span>
                    </div>
                  )}
                </Col> */}
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="password"
                    text="Create Password"
                    type="password"
                    placeholder="Enter new password"
                    field={"password"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.password?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"password"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="confirmPassword"
                    text="Confirm Password"
                    type="password"
                    placeholder="Enter confirm password"
                    field={"confirmPassword"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.confirmPassword?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage
                          errors={errors}
                          name={"confirmPassword"}
                        />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default RRoomsUsers;
